import * as Yup from 'yup'

const validationSchema = Yup.object({
  name: Yup.string().required('Lab Test Name is required'),
  categoryId: Yup.number().required('Category is required'),
  sampleTypeIds: Yup.array()
    .of(
      Yup.number()
        .typeError('Sample Types is required')
        .required('Each item is required'),
    )
    .min(1, 'At least one sample type is required')
    .required('Sample Types is required'),
  shortcode: Yup.string().required('Shortcode is required'),
})

export default {
  validationSchema,
}
